import React, {
    PureComponent
} from 'react';
import AnimatedView from '../../../../components/componentsGeneral/AnimatedView/AnimatedView';
import LoadContainer from '../../../../components/componentsInventoryManagement/_Lot_Tracking_Components/Load/LoadContainer';
import { Message } from 'rsuite';
import { lotTrackingWarehouseIDs } from '../../../../app/appConfig';

class invManLotLoadView extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {

        };
    }
    
    componentDidMount() {

    }

    render() {

        if (!lotTrackingWarehouseIDs.includes(this.props.warehouseSelection) && !lotTrackingWarehouseIDs.includes("All")) {
            return <AnimatedView><Message style={{ marginTop: '25px' }} type="info" description="Please only select Lot Tracking warehouses" /></AnimatedView>;
        }

        return (
            <AnimatedView>
                <LoadContainer isMobile={this.props.isMobile} warehouseSelection={this.props.warehouseSelection} customerSelection={this.props.customerSelection}/>
            </AnimatedView>

        );
    }
}

export default invManLotLoadView;
